<template>
  <div class="side-menu-layout">
    <!-- 左侧二级菜单 -->
    <div class="left-menu">
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical"
        @select="handleMenuSelect"
      >
        <el-menu-item index="userManager">
          <i class="el-icon-user"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>
        <el-menu-item index="roleManager">
          <i class="el-icon-s-check"></i>
          <span slot="title">角色管理</span>
        </el-menu-item>
      </el-menu>
    </div>
    
    <!-- 右侧内容区域 -->
    <div class="right-content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideMenuLayout',
  computed: {
    activeMenu() {
      // 根据当前路由路径确定激活的菜单项
      const path = this.$route.path;
      if (path.includes('userManager')) {
        return 'userManager';
      } else if (path.includes('roleManager')) {
        return 'roleManager';
      }
      return 'userManager'; // 默认激活用户管理
    }
  },
  methods: {
    handleMenuSelect(index) {
      // 根据选择的菜单项进行路由跳转
      if (index === 'userManager') {
        this.$router.push('/userManager');
      } else if (index === 'roleManager') {
        this.$router.push('/roleManager');
      }
    }
  }
}
</script>

<style scoped>
.side-menu-layout {
  display: flex;
  height: 100%;
}

.left-menu {
  width: 200px;
  height: 100%;
  border-right: 1px solid #e6e6e6;
}

.right-content {
  flex: 1;
  padding: 0 15px;
  overflow-y: auto;
}

.el-menu-vertical {
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/layout/SideMenuLayout.vue